import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BatchPaymentService = {
  async getGenerateData(payload) {
    const url = `api/BatchPaymentRun/Generate`;
    // const url = `api/BatchPaymentGenerate`;
    return await ApiService.post(url, payload);
  },
  async saveAsDraft(payload) {
    const url = `api/BatchPaymentRun/SaveDraft`;
    return await ApiService.post(url, payload);
  },
  async Commit(payload) {
    const url = `api/BatchPaymentRun/SaveCommit`;
    return await ApiService.post(url, payload);
  },
  async cancel(payload) {
    const url = `api/BatchPaymentRun/Cancel`;
    return await ApiService.post(url, payload);
  },
  async getCustomData(url, RunId) {
    let requestData = {
      url,
      filter: `RunId eq ${RunId} and LineOk eq 'Y'`,
    };
    return await ApiService.oDataGet(requestData);
  },
  async getAPFactor() {
    let requestData = {
      url: "api/APFactor",
    };
    return await ApiService.oDataGet(requestData);
  },
  async getCurrentAccountingPeriod(periodCode) {
    const getCurrentAccountingPeriod = {
      url: "api/AccountingPeriod",
      filter: `Code eq '${periodCode}'`,
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriod);
  },
  async getCurrentAccountingPeriodEndDate() {
    const getCurrentAccountingPeriodEndDate = {
      url: "api/AccountingPeriod",
      orderby: "DateEnd desc",
      top: 1,
    };
    return await ApiService.oDataGet(getCurrentAccountingPeriodEndDate);
  },
  async getLastRunId(url) {
    let requestData = {
      url,
      select: ["RunId"],
      orderby: "RunId desc",
      top: 1,
    };
    return await ApiService.oDataGet(requestData);
  },

  async getGroupedData(url) {
    let requestData = {
      url,
    };
    return await ApiService.oDataGet(requestData);
  },
  async getBatchPaymentRun(RunId) {
    let requestData = {
      url: "api/BatchPaymentRun",
      filter: `RunId eq ${RunId}`,
      expand: `BatchPaymentSupplierFilters($select=SupplierCode),BatchPaymentSupplierTypeFilters($select=SupplierTypeCode)`,
    };
    return await ApiService.oDataGet(requestData);
  },

  async getBatchPaymentSupplier(RunNo) {
    let requestData = {
      url: "api/BatchPaymentSupplier",
      filter: `RunNo eq ${RunNo}`,
    };
    return await ApiService.oDataGet(requestData);
  },

  async getBatchPaymentInvoiceLine(RunId) {
    let requestData = {
      url: "api/BatchPaymentInvoiceLine",
      filter: `RunId eq ${RunId}`,
    };
    return await ApiService.oDataGet(requestData);
  },


  async getRemittanceDistribution(RunNo) {
    let requestData = {
      url: "api/RemittanceDistributionRun",
      filter: `RunId eq ${RunNo}`,
    };
    return await ApiService.oDataGet(requestData);
  },

  async saveRemittanceDistribution(payload) {
    const url = `api/RemittanceDistributionRun`;
    return await ApiService.post(url, payload);
  },
};
export { BatchPaymentService };
